import { Link, useLocation } from "react-router-dom";
import {
    Menu,
    X,
    Home,
    Book,
    Phone,
    Info,
    Tv,
    Moon,
    MoreVertical,
    Share2,
    Facebook,
    MessageCircle,
} from "lucide-react";
import ThemeIcons from "./ThemeIcons";

const MobileTaskbar = ({
  isMobile,
  isDrawerOpen,
  setIsDrawerOpen,
  isThemeDropdownOpen,
  setIsThemeDropdownOpen,
  menuOpen,
  setMenuOpen,
  hideTopBar,
  hideBottomBar,
  themeBtnRef,
  themeDropdownRef,
  menuRef,
}) => {
  const location = useLocation();

  const mobileLinks = [
  { path: "/", label: "Home", icon: <Home size={20} /> },
  { path: "/live-tv", label: "Live", icon: <Tv size={20} /> },
  { path: "/books", label: "Books", icon: <Book size={20} /> },
  { path: "/contact", label: "Contact", icon: <Phone size={20} /> },
  { path: "/about", label: "About", icon: <Info size={18} /> },
];


  return (
    <>
      {/* TOP BAR */}
      <div
        className={`fixed top-0 text-text left-0 right-0 z-50 bg-card transition-transform duration-300 ${
          hideTopBar ? "-translate-y-full" : "translate-y-0"
        }`}
      >
        <div className="flex justify-between p-1">
          <Link to="/" className="flex items-center gap-1">
            <img
              src="images/taskbar/taskbar.png"
              alt="Logo"
              className="h-10 w-10 rounded-full"
            />
            <span className="text-xl font-bold text-secondary max-[359px]:text-[17px]">
              Prophet Kevin Online
            </span>
          </Link>

          <div className="flex items-center">
            <button
              ref={themeBtnRef}
              onClick={() => setIsThemeDropdownOpen((p) => !p)}
            >
              <Moon />
            </button>

            <button
              onClick={() => {
                setIsThemeDropdownOpen(false);
                setIsDrawerOpen(true);
              }}
              className="ml-4"
            >
              <Menu />
            </button>
          </div>

          {isThemeDropdownOpen && (
            <div
              ref={themeDropdownRef}
              className="absolute right-2 top-[82px] bg-purple-500 text-white rounded shadow-lg z-50 text-center pt-2"
            >
              <ThemeIcons isDropdown />
              select your theme
            </div>
          )}
        </div>
      </div>

      {/* ================= MOBILE DRAWER ================= */}
      {isMobile && isDrawerOpen && (
        <>
          <div
            className="fixed inset-0 z-40 bg-black/40"
            onClick={() => setIsDrawerOpen(false)}
          />

          <div className="fixed border border-border rounded top-0 right-0 w-64 h-full text-text bg-card z-50 p-4 shadow-lg flex flex-col">
            <button
              onClick={() => setIsDrawerOpen(false)}
              className="self-end p-1 hover:text-hover"
              aria-label="Close menu"
            >
              <X />
            </button>

            <div className="flex flex-col items-center mt-3 mb-6">
              <img
                src="images/taskbar/taskbar.png"
                alt="Logo"
                className="h-14 w-14 rounded-full mb-2"
              />
              <span className="text-xl font-bold text-secondary text-center">
                Prophet Kevin Online
              </span>
            </div>

            <div className="space-y-3 flex-1 overflow-y-auto">
              {mobileLinks.map(({ path, label, icon }) => (
                <Link
                  key={path}
                  to={path}
                  onClick={() => setIsDrawerOpen(false)}
                  className={`flex items-center gap-3 px-3 py-2 rounded transition ${
                    location.pathname === path
                      ? "bg-accent text-primary"
                      : "hover:bg-bg hover:text-hover"
                  }`}
                >
                  {icon}
                  <span>{label}</span>
                </Link>
              ))}

              <Link
                to="/give"
                onClick={() => setIsDrawerOpen(false)}
                className="block text-center bg-yellow-500 hover:bg-yellow-400 text-black font-semibold rounded py-2 mt-4"
              >
                Give
              </Link>
            </div>
            <div className=" bg-purple-500 h-12 w-full rounded">
            <div className="absolute bottom-5 right-6">
              <ThemeIcons />
            </div>
            </div>
          </div>
        </>
      )}

      {/* BOTTOM BAR */}
      <div
        className={`fixed bottom-0 left-0 text-text right-0 bg-card border-t z-50 transition-transform ${
          hideBottomBar || isDrawerOpen
            ? "translate-y-full"
            : "translate-y-0"
        }`}
      >
        <div className="flex justify-around py-3">
          <Link to="/" className="flex flex-col items-center">
            <Home className="w-6 h-4" />
            <span className="text-xs">Home</span>
          </Link>

          <Link to="/live-tv" className="flex flex-col items-center">
            <Tv className="w-6 h-4" />
            <span className="text-xs">Live</span>
          </Link>

          <Link to="/books" className="flex flex-col items-center">
            <Book className="w-6 h-4" />
            <span className="text-xs">Books</span>
          </Link>

          <div ref={menuRef} className="relative flex flex-col items-center">
            <button onClick={() => setMenuOpen((p) => !p)}>
              <MoreVertical className="w-6 h-4" />
            </button>
            <span className="text-xs">More</span>

            {menuOpen && (
              <div className="absolute bottom-[52px] right-0 w-[250px] bg-card border rounded shadow-lg">
                <button className="flex gap-3 px-4 py-3 w-full">
                  <Share2 size={18} /> Share Website
                </button>
                <button className="flex gap-3 px-4 py-3 w-full">
                  <Facebook size={18} /> Facebook
                </button>
                <button className="flex gap-3 px-4 py-3 w-full">
                  <MessageCircle size={18} /> WhatsApp
                </button>
                <button className="flex gap-3 px-4 py-3 w-full">
                  🎵 TikTok
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileTaskbar;
